import React from 'react'

export const Flag = ({ style }: { style?: React.CSSProperties }) => (
  <svg width='15' height='15' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg' style={style}>
    <g clipPath='url(#clip0)'>
      <path
        d='M16.9725 7.20286C16.9087 7.1257 16.8738 7.02871 16.8738 6.92857C16.8738 6.82844 16.9087 6.73144 16.9725 6.65429L20.3445 2.60857C20.5009 2.42085 20.6005 2.19248 20.6318 1.95018C20.663 1.70788 20.6246 1.4617 20.521 1.24045C20.4174 1.0192 20.2529 0.832056 20.0468 0.700921C19.8406 0.569786 19.6014 0.500092 19.3571 0.5L5.64283 0.5C5.30184 0.5 4.97481 0.635459 4.73369 0.876577C4.49258 1.1177 4.35712 1.44472 4.35712 1.78571V23.2143C4.35712 23.5553 4.49258 23.8823 4.73369 24.1234C4.97481 24.3645 5.30184 24.5 5.64283 24.5C5.98382 24.5 6.31085 24.3645 6.55197 24.1234C6.79309 23.8823 6.92855 23.5553 6.92855 23.2143V13.7857C6.92855 13.6721 6.9737 13.563 7.05407 13.4827C7.13444 13.4023 7.24345 13.3571 7.35712 13.3571H19.3571C19.6014 13.3571 19.8406 13.2874 20.0468 13.1562C20.2529 13.0251 20.4174 12.8379 20.521 12.6167C20.6246 12.3954 20.663 12.1493 20.6318 11.907C20.6005 11.6647 20.5009 11.4363 20.3445 11.2486L16.9725 7.20286Z'
        fill='#FF565C'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <rect width='24' height='24' fill='none' transform='translate(0.5 0.5)' />
      </clipPath>
    </defs>
  </svg>
)

export default Flag
